<template>
  <div class="change-password-wrapper">
    <logged-in-user-header v-if="hasPassword"></logged-in-user-header>
    <change-password-container></change-password-container>
  </div>
</template>

<script>
import LoggedInUserHeader from '@/common/LoggedInUserHeader';

import {mapGetters} from 'vuex';

import ChangePasswordContainer from '@/pages/change-password/ChangePasswordContainer';

export default {
  computed: {
    ...mapGetters(['userState']),
    hasPassword() {
      return this.userState.details.has_password;
    }
  },
  components: {
    LoggedInUserHeader,
    ChangePasswordContainer
  }
};
</script>
<style lang="scss" scoped>
@import '~VariablesStyles';

@media screen and (min-width: $tablet) {
  .change-password-wrapper {
    height: 100vh;
  }
}
</style>
